module.exports = __webpack_public_path__ + "static/twitter-40fcb4a61df3d9bf6900da78404d10f9.png";